/** Login przekazany do formularza logowania to email, jeśli zawiera "@" (numer telefonu nigdy go nie ma) */
export const isEmailLogin = (login?: string | null) => !!login && login.includes('@')

/** Ścieżka do logowania z uzupełnionym loginem — zakodowana, żeby np. "+" w emailu/telefonie nie zamienił się w spację */
export const loginPath = (login?: string | null) =>
  login ? `/login?${new URLSearchParams({ login })}` : '/login'
